<table
        (matSortChange)="onSortChange($event)"

        [dataSource]="dataSource"

        mat-table
        matSort
        style="width: 100%"
>
    <!-- <ng-container matColumnDef="action">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
       N°
      </th>
      <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
    </ng-container> -->

    <ng-container matColumnDef="rcvNo">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "qna_num_reception" | translate }}
        </th>
        <td *matCellDef="let d" class="text-center" mat-cell>{{ d.rcvNo }}
        </td>
    </ng-container>


    <ng-container matColumnDef="title">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>

            {{ "faq_title" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell width="30%">
            <a [queryParams]="{ id: d.ptQnaId }" [routerLink]="['/portail/qna/qnacard']" class="st-p">
                {{ d.title }}</a>
        </td>
    </ng-container>


    <ng-container matColumnDef="writerCdNmAr">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "qna_classification" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell width="20%">
            {{ d.writerCdNmAr }}/{{ d.qnaSubClNmAr }}/{{ d.qnaCdNmAr }}
        </td>
    </ng-container>


    <ng-container matColumnDef="writerNm">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "faq_redacteur" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>{{ d.writerNm }}</td>
    </ng-container>

    <ng-container matColumnDef="regDt">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "modDt_rédaction" | translate }}
        </th>
        <td *matCellDef="let d" class="text-center" mat-cell>{{ d.regDt | date : 'dd/MM/yyyy' }}</td>
    </ng-container>


    <ng-container matColumnDef="hitCnt">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "nb_consult" | translate }}
        </th>
        <td *matCellDef="let d" class="text-center" mat-cell>{{ d.hitCnt }}</td>
    </ng-container>


    <!--  <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">

       <th *matHeaderCellDef mat-header-cell mat-sort-header>
         {{ column | translate }}
       </th>

       <td *matCellDef="let type" mat-cell>
         {{ type[column] | typedValue | async }}
       </td>
     </ng-container> -->
    <tr *matHeaderRowDef="readColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: readColumns" mat-row></tr>


</table>
<app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
